<template>
    <div>
         <!-- <button type="button" onclick="printJS('https://cdn.unityerp.com/dbase/sales/hktvm/waybills/5501070841.pdf')">
            Print PDF
        </button> -->
        <!-- <b-button @click="printPdf('https://cdn.unityerp.com/dbase/sales/hktvm/waybills/5501070841.pdf')">print</b-button>
        <pdf ref="myPdfComponent" :src="pdfFile"></pdf> -->
    
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active="loadingCounter > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="false" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6">
            <b-row class="mb-4" v-if="func == 'calendar'">
                <b-col>
                    <v-calendar
                    class="custom-calendar max-w-full"
                    :masks="masks"
                    :attributes="attributes"
                    disable-page-swipe
                    is-expanded
                    >
                    <template v-slot:day-content="{ day, attributes }">
                        <div style="min-height:76px" class="mr-1 ml-1 flex flex-col h-full z-10 overflow-hidden">
                        <span class="day-label text-sm text-gray-900"><div style="text-align:center">{{ day.day }}</div></span>
                        <div class="flex-grow overflow-y-auto overflow-x-auto">
                            <b-button v-for="attr in attributes" block
                            :key="attr.key"
                            class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                            :class="attr.customData.class"
                            style="text-align:center" @click="clickOnCalendarSlot(attr)"
                            >
                            {{ attr.customData.title }}
                            </b-button>
                        </div>
                        </div>
                    </template>
                    </v-calendar>
                </b-col>
                <template v-if="selectedSlotsCount > 0">
                    <fab
                    :position="position"
                    :bg-color="bgColor"
                    :actions="fabActions1"
                    @pick="clickOnPick"
                    main-icon="bolt"
                    v-if="loadingCounter == 0"
                    ></fab>
                </template>
            </b-row>

            <b-row class="mb-4" v-if="func == 'generate'">
                <template v-if="selectedSlotsCount > 0">
                    <fab
                    :position="position"
                    :bg-color="bgColor"
                    :actions="fabActions2"
                    @generate="clickOnGenerate"
                    @back="clickOnBack"
                    main-icon="bolt"
                    v-if="loadingCounter == 0"
                    ></fab>
                </template>

                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <h3>{{language_terms['PICKLIST_CONFIRMATION']}}</h3>
                        </div>
                        <b-row>
                            <b-col cols="6">
                                <base-input ref="inputPicklistCode" :label="language_terms['NAME']" v-model="picklist.code"/>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['DATE']">
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="picklist.date">
                                    </flat-picker>
                                </base-input>
                            </b-col>

                            <b-col md="12" class="mb-4">
                                <label class="form-control-label">{{language_terms['PICKUP_SLOTS']}}</label>
                                <multiselect
                                        :placeholder="language_terms['PICKLISTS']"
                                        open-direction="bottom"
                                        label="name"
                                        track-by="id"
                                        :options="picklist.slots"
                                        text-field="name"
                                        :multiple="true"
                                        v-model="picklist.slots"
                                        :taggable="false"
                                        >
                                </multiselect>
                            </b-col>
                            <b-col cols="12">
                                <base-input :label="language_terms['REMARKS']" >
                                    <textarea class="form-control" rows="3" v-model="picklist.remarks"></textarea>
                                </base-input>                        
                            </b-col>
                        </b-row>
                        <b-row>
                            
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <b-modal centered header-bg-variant="light" header-text-variant="" title="Confirmation" v-model="modalConfirmBatchClose" @ok="confirmCloseBatch()">
            Proceed to close batch?
        </b-modal>

        <b-modal  hide-backdrop content-class="shadow" centered title="Error" v-model="modalError" ok-only>
            <p class="my-2">{{modalErrorMessage}}</p>
        </b-modal>

    </div>
    
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
</style>
<script>
import * as Printjs from "print-js"
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import { mapState } from "vuex";
import axios from "axios";
import fab from 'vue-fab'  

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from 'element-ui'


export default {
    name:'Location-Details',
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            storage_classifications: state => state.storageclassifications.storage_classifications,
            active_locations: state => state.locations.active_locations,
            location_created: state => state.locations.is_created,
            location_updated: state => state.locations.is_updated,
            location_filter: state => state.locations.filter,
            location_data: state => state.locations.data
        })
    },
    data(){
        return{
            waybill_code:null,
            modalError:false,
            modalErrorMessage: '',
            waybill:null,
            gtin:'',
            modalConfirmBatchClose:false,
            isPickListBatchClosed: true,
            pdfFile: '',
            pickingColumns:['id','location', 'qty', 'product_name', 'brand', 'qty_open', 'action'],
            // pickingOptions:{groupBy :['location', 'brand']},
            pickingOptions:{perPage:10000, perPageValues:[],stickyHeader:false, stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:true
            ,texts:{count:"", filter: "", filterPlaceholder: "Quick Lookup",}
            ,editableColumns: ['qty_open']                        
            ,sortIcon: {
            is: "glyphicon-sort",
            base: "glyphicon",
            up: "glyphicon-chevron-up",
            down: "glyphicon-chevron-down"
            },
            sortingAlgorithm(data, column) {
            return data.sort(this.getSortFn(column));
            },
            },

            pickingItems: [],
            selectedClassification: null,
            picklist:{
                code:null,
                stats:{}
            },
            func:'calendar',
            loadingCounter:0,
            title:"",
            is_edit:false,
            bgColor: '#17BA19',
            position: 'bottom-right',
            fabActions1: [
                {
                    name: 'pick',
                    icon: 'launch'
                }
            ]
            ,
            fabActions2: [
                {
                    name: 'back',
                    icon: 'arrow_back',
                    color: 'red',
                },
                {
                    name: 'generate',
                    icon: 'send',
                    color: 'green'
                }                
            ],          
            selectedSlotsCount:0,
            masks: {
            weekdays: 'WWW',
            },
            attributes: [],
        }
    },
    components:{
        flatPicker,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        fab,
    },
    async mounted()
    {
        await this.retrieveSalesFulfillmentCalendar()
    },
    methods:{
        playSound (sound)
        {
            if(sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        promptError(msg)
        {
            this.playSound('https://cdn.unityerp.com/core/sounds/ding.mp3')
            this.modalErrorMessage = msg
            this.modalError = true
        },
        async packScanGTIN()
        {
            let payload = {picklist_id: this.picklist.id, waybill_code: this.waybill_code, gtin:this.gtin}
            axios.post(apiRoutes["WAYBILL_AUTO_GTIN_SCAN"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    if (response.data.msg == '')
                        this.promptError('GTIN not found')
                    else
                    {
                        this.waybill = response.data.data
                        if (!this.waybill.gtin_added)
                            this.playSound('https://cdn.unityerp.com/core/sounds/ding.mp3')
                        else
                            this.playSound('https://cdn.unityerp.com/core/sounds/pop.mp3')

                        if (this.waybill_code == null)
                        {
                            printJS('https://cdn.unityerp.com/dbase/sales/hktvm/waybills/' + this.waybill.waybill_code + '.pdf')
                        }
                        this.waybill_code = this.waybill.waybill_code
                        
                        if (this.waybill.items_outstanding.length == 0)
                        {
                            this.playSound('https://cdn.unityerp.com/core/sounds/nice.mp3')
                            this.waybill_code = null
                        }
                    }
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                } 
                else 
                {
                    console.log("Problem Querying Data", error);
                }
            });
        },
        clickOnPack()
        {
            this.func='packing'
        },
        confirmCloseBatch()
        {
            let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification}
            axios.post(apiRoutes["PICKLIST_CLOSE_BATCH"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.isPickListBatchClosed = true    
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                } 
                else 
                {
                    console.log("Problem Querying Data", error);
                }
            });

        },
        closeBatch()
        {
            this.modalConfirmBatchClose = true
        },
        clickOnPickItem(row)
        {
            for (let x = 0; x < this.pickingItems.length; x++) {
                if (this.pickingItems[x].id == row.id)
                {
                    let payload = {picklist_item_id: row.id, qty: row.qty_open}
                    axios.post(apiRoutes["PICKLIST_UPDATE_ITEM_QTY_INCREMENTAL"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) 
                        {
                            this.$delete(this.pickingItems, x)
                        } 
                    })
                    .catch((error) => 
                    {
                        if (error.response) 
                        {
                            Vue.notify({
                                group: "notify",
                                type: "error",
                                text: error.response.data.msg,
                                max: 5,
                                duration: 5000,
                                speed: 300,
                            });
                        } 
                        else 
                        {
                            console.log("Problem Querying Data", error);
                        }
                    });
                    break
                }
            }            
        },
        onSelectClassification()
        {
            let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification, filter_qty_open:true, filter_batch_closed:false};
            axios.post(apiRoutes["PICKLIST_RETRIEVE_ITEMS_BY_CLASSIFICATION"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.isPickListBatchClosed = response.data.data.is_batch_closed
                    this.pickingItems = response.data.data.items
                    this.loadingCounter--
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    this.loadingCounter--

                Vue.notify({
                    group: "notify",
                    type: "error",
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300,
                });
                } 
                else 
                {
                console.log("Problem Querying Data", error);
                }
            });

        },
        clickOnBack()
        {
            this.func = 'calendar'
        },
        clickOnPickProcess()
        {
            this.func = 'picking'
        },
        async clickOnGenerate()
        {
            if (this.picklist.slots.length > 0)
            {
                this.loadingCounter++
                this.picklist.slots = this.picklist.slots
                let payload = this.picklist;
                axios.post(apiRoutes["PICKLIST_GENERATE_FROM_WAYBILL_SLOTS"], payload, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        this.retrieveSalesFulfillmentCalendar();
                        this.func = 'calendar';
                        this.loadingCounter--
                    }
                    else
                    {
                        this.loadingCounter--

                        Vue.notify({
                            group: "notify",
                            type: "error",
                            text: response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });

                        this.$nextTick(() => {
                            if (this.$refs.inputPicklistCode && this.$refs.inputPicklistCode.$el) {
                            const inputEl = this.$refs.inputPicklistCode.$el.querySelector('input');
                            if (inputEl) inputEl.focus();
                            }
                        });
                    } 
                })
                .catch((error) => 
                {
                    if (error.response) 
                    {
                        this.loadingCounter--

                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                    } 
                    else 
                    {
                    console.log("Problem Querying Data", error);
                    }
                });
            }
            else
            {
                alert('Empty pickup slot')
            }
            
        },
        clickOnPick()
        {
            this.picklist.slots = [];
            this.picklist.date = moment().format("YYYY-MM-DD");

            this.attributes.forEach((attribute) => {
                if (attribute.customData.selected) {
                let slot = { id: attribute.key, name: attribute.customData.delivery_eta_date_short };
                this.picklist.slots.push(slot);
                }
            });

            this.func = 'generate';

            // Wait until DOM updates before focusing
            this.$nextTick(() => {
                if (this.$refs.inputPicklistCode && this.$refs.inputPicklistCode.$el) {
                const inputEl = this.$refs.inputPicklistCode.$el.querySelector('input');
                if (inputEl) inputEl.focus();
                }
            });
        },
        clickOnCalendarSlot(slot)
        {
            if (slot.customData.type == 'picklist')
            {
                this.$router.push("/inventory/job/" + slot.customData.title)
            }
            else if (slot.customData.type == 'delivery_slot')
            {
                slot.customData.selected = !slot.customData.selected
                if (slot.customData.selected)
                {
                    slot.customData.class = 'bg-green text-white'
                    this.selectedSlotsCount++
                }
                else
                {
                    slot.customData.class = slot.customData.oclass
                    this.selectedSlotsCount--
                }

                this.attributes.forEach((attribute) => {
                    if (attribute.customData.selected)
                        this.picklist.slots.push(attribute.key);
                });
            }
        },
        async retrievePickList(picklist_code)
        {
            this.loadingCounter++
            let payload = {code: picklist_code}
            axios.post(apiRoutes["PICKLIST_RETRIEVE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.picklist = response.data.data
                    this.loadingCounter--
                } 
            })
            .catch((error) => 
            {
                this.loadingCounter--
                if (error.response) 
                {
                Vue.notify({
                    group: "notify",
                    type: "error",
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300,
                });
                } 
                else 
                {
                console.log("Problem Querying Data", error);
                }
            });
        },
        async retrieveSalesFulfillmentCalendar()
        {
            this.loadingCounter++
            this.attributes = []
            let payload = { year: this.year, month: this.month};
            axios.post(apiRoutes["DBASE_RETRIEVE_SALES_FULFILLMENT_CALENDAR"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                this.attributes = response.data.data
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                Vue.notify({
                    group: "notify",
                    type: "error",
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300,
                });
                } 
                else 
                {
                console.log("Problem Querying Data", error);
                }
            });

            this.picklist.slots = []
            this.picklist.slotsCount = 0

            this.loadingCounter--
        },
        async create()
        {

        },
        async update()
        {

        },
        cancel()
        {

        }
    }
}
</script>
